export const colors = {
	dark: o => `rgba(44, 62, 80, ${o})`,
	gray: o => `rgba(127, 140, 141, ${o})`,
	red: o => `rgba(231, 76, 60, ${o})`,
	green: o => `rgba(46, 204, 113, ${o})`,
	blue: o => `rgba(41, 128, 185, ${o})`
}